<template>
    <v-dialog v-model="dialog" persistent max-width="330">
        <template v-slot:activator="{ on }">
            <div class="action_item" v-on="on">
                <font-awesome-icon
                    class="action-icon"
                    icon="trash-alt"
                /><span class="delete">delete account</span>
            </div>
        </template>
        <v-card class="modal">
            <v-card-title>
                <font-awesome-icon
                    class="delete_header"
                    icon="info-circle"
                />
                <p>Team Delete Confirmation</p>
            </v-card-title>
            <v-card-text>
                Are you sure you want to <span class="bold">delete</span> this account <span class="bold">permanently</span>?                
            </v-card-text>
            <v-card-actions>
                <v-btn small class="delete" @click="deleteAccount()">Yes</v-btn>
                <v-btn small class="cancel" @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['item'],
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        deleteAccount() {            
            const data = {
                user_id: this.item.id
            };
            this.$store.dispatch("deleteAccount", data).then(response => {
                this.$store.dispatch("getAllUsers");
                this.dialog = false;
            }).catch(() => {
                this.dialog = false;
            });
        },
    }
}
</script>